<div class="flex h-full flex-col" ridangoAppTrapFocus>
    <div class="sticky top-0 z-10 bg-white">
        <div
            class="relative flex min-h-[48px] flex-row items-center justify-center border-b border-solid border-black border-opacity-10 dark:border-contrast-yellow">
            <ion-button
                class="absolute left-0 mr-1"
                [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
                (click)="handleBackClicked()"
                fill="clear"
                type="button">
                <ion-icon
                    class="var-app-light:text-primary gl-light:text-secondary text-xl dark:filter-yellow"
                    [src]="(assetsPath$ | async) + '/img/journey-planner/icon-arrow.svg'"
                    aria-hidden="true"></ion-icon>
            </ion-button>

            <h1
                class="orb-app-light-dark:font-bold var-app-light-dark:font-bold text-center text-base font-semibold leading-5">
                {{ 'BUY_NEW_TICKET' | translate }}
            </h1>

            <ion-button
                class="absolute right-1"
                *ngIf="shouldShowCloseButton"
                [attr.aria-label]="'LOCAL_BTN_CLOSE' | translate"
                (click)="handleClosePurchasePage()"
                type="button"
                fill="clear">
                <ion-icon
                    class="var-app-light:text-primary text-2xl dark:filter-yellow"
                    [src]="(assetsPath$ | async) + '/img/explore/cross.svg'"
                    aria-hidden="true"></ion-icon>
            </ion-button>
        </div>
        <div class="border-b border-solid border-black border-opacity-10 dark:border-contrast-yellow"></div>
    </div>
    <!-- Had to add block, since purchase flow has it and without it account selector was pushed to right -->
    <div class="block">
        <gl-account-selector
            *ngIf="env.PURCHASE_FLOW?.SHOW_USER_ACCOUNT_CHOICE && activeStep === 0"></gl-account-selector>
    </div>
    <rwidget-alert></rwidget-alert>
    <div class="flex-1" *ngIf="isLoading$ | async">
        <ridango-ui-basic-loading-spinner></ridango-ui-basic-loading-spinner>
    </div>
    <div class="flex-1 overflow-y-auto" *ngIf="(isLoading$ | async) === false">
        <ng-container [ngSwitch]="stepFromUrl">
            <div *ngSwitchCase="'category-product'">
                <rwidget-purchase-ticket-category-product
                    [urls]="urls"
                    [zone]="zone"
                    [zones]="zones"
                    [categoryProducts]="categoryProducts"
                    [showZone]="env.PURCHASE_FLOW?.SHOW_ZONE_IN_JOURNEY_PLANNER_PURCHASE === true"
                    [duration]="duration"
                    (nextStep)="handleNextClicked()"></rwidget-purchase-ticket-category-product>
            </div>
            <div *ngSwitchCase="'product'">
                <rwidget-purchase-ticket-product
                    [urls]="urls"
                    [zone]="zone"
                    [categoryProducts]="categoryProducts"
                    (nextStep)="handleNextClicked()"></rwidget-purchase-ticket-product>
            </div>
            <div *ngSwitchCase="'ticket-activation'">
                <gl-purchase-v2-ticket-activation
                    [isJourneyPlannerPurchase]="true"
                    [categoryProducts]="categoryProducts"
                    [isShowInnerNextButton]="true"
                    (nextStep)="handleNextClicked()"
                    (backStep)="handleBackClicked()"></gl-purchase-v2-ticket-activation>
            </div>
        </ng-container>
    </div>
    <div class="sticky bottom-0 z-10 w-full bg-white">
        <div class="flex px-4" *ngIf="stepFromUrl === 'product'">
            <ion-button
                class="next-button var-app-light:text-black orb-app-light:text-black my-4 w-full"
                [attr.aria-label]="
                    ('CONTINUE_TO_CHECKOUT' | translate) +
                    ' (' +
                    (getTotalAmount() | moneyFormat) +
                    ' ' +
                    (continueToCheckoutCurrency || currency) +
                    ')'
                "
                [disabled]="!nextButtonEnabled()"
                (click)="handleNextClicked()"
                size="large"
                fill="clear">
                <ion-label
                    class="vl-app-light:text-black whitespace-normal text-base font-bold normal-case dark:text-contrast-black">
                    {{ 'CONTINUE_TO_CHECKOUT' | translate }} ({{ getTotalAmount() | moneyFormat }}
                    {{ continueToCheckoutCurrency || currency }})
                </ion-label>
                <ion-icon
                    class="orb-app-light:text-black var-app-light:text-black vl-app-light:text-black"
                    name="arrow-forward-outline"
                    slot="end"></ion-icon>
            </ion-button>
        </div>
        <div class="flex-center flex h-12 justify-evenly px-4" *ngIf="(isLoading$ | async) === false">
            <ion-icon
                class="h-3 text-5xl"
                *ngFor="let section of this.steps; let index = index"
                [ngClass]="{ 'text-grey-zambezy': index <= activeStep, 'text-grey-white_smoke': index > activeStep }"
                src="{{ assetsPath$ | async }}/img/purchase-flow-v2/{{
                    index <= activeStep ? 'step-active.svg' : 'step-inactive.svg'
                }}"></ion-icon>
        </div>
    </div>
</div>
